import { EducatorsTeamApplicationsTeamApplication } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type NewProps = {
  team_application: EducatorsTeamApplicationsTeamApplication
  team_profile_id: string
}

export type ShowProps = {
  team_application: EducatorsTeamApplicationsTeamApplication
}

export type CreateParams = {
  team_application: {
    team_profile_id: number
    state: "consideration" | "ready_to_accept"
  }
  message: string
}

export const useNewProps = () => useProps<NewProps>()
export const useShowProps = () => useProps<ShowProps>()
